import { render, staticRenderFns } from "./SalesItemList.vue?vue&type=template&id=77fd77f2&"
import script from "./SalesItemList.vue?vue&type=script&lang=js&"
export * from "./SalesItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports